import React, {useEffect, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import Carousel from '../../../../components/Carousel'
import moment from 'moment/moment'
import {copyText} from "../../../../components/renders";

const DetailsPieceModal = ({dataSuggestion, isFromPanier}) => {
  const [imgArr, setImgArr] = useState<any>([])
  const [checkCopy, setCheckCopy] = useState<string | null>(null)

  useEffect(() => {
    setImgArr(dataSuggestion?.images)
  }, [dataSuggestion])

  const handleCopie = (texte, e) => {
    e.stopPropagation()
    copyText(texte, setCheckCopy, 500)
  }

  const getEtatColorIndicator = () => {
    let etatColorIndicator
    const etat = dataSuggestion?.etat?.toLowerCase()
    if (etat) {
      switch (etat) {
        case "très bien":
          etatColorIndicator = "primary"
          break;
        case "bien":
          etatColorIndicator = "success"
          break;
        case "moyen":
          etatColorIndicator = "yellow"
          break;
        case "nc":
          etatColorIndicator = "orange"
          break;
        default:
          etatColorIndicator = "grey"
          break;
      }
      return etatColorIndicator
    } else return ''
  }

  const renderInfo = () => {
    const capitalizaFirstletter = (str: string = '') => {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    }

    // Supprimer les "//" et mettre le texte en Abcdef
    const formatTexte = (str: string): string => {
      if (!str) return ''

      const result = str
        .replace(/\\r\\n|\r?\n|\\/g, ',') // retours ligne et backslashes → virgule
        .split(',') // découper sur virgule
        .map((s) => s.trim()) // enlever espaces
        .filter(Boolean) // supprimer morceaux vides
        .join(', ') // reconstruire avec virgule + espace

      return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase()
    }

    return (
      <div className='overflow-auto' style={{maxHeight: '500px'}}>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Réference constructeur</div>
          <div className='fs-4 bold'>
            <div className='d-flex gap-2'>
              {dataSuggestion?.reference ?? dataSuggestion?.refConstructeur ?? ''}
              {(dataSuggestion?.reference || dataSuggestion?.refConstructeur) &&
                (checkCopy !== (dataSuggestion?.reference ?? dataSuggestion?.refConstructeur) ? (
                  <i
                    className='ki-duotone ki-copy cursor-pointer fs-2'
                    onClick={(e) => handleCopie(dataSuggestion?.reference ?? dataSuggestion?.refConstructeur ?? '', e)}
                  ></i>
                ) : (
                  <i className='ki-duotone ki-copy-success fs-2'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                ))}
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Prix constructeur (HT)</div>
          <div className='fs-4 bold'>
            {dataSuggestion?.prixConstructeur ? `${Number(dataSuggestion?.prixConstructeur)?.toFixed(2)} €` : 'Nc'}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Réference pièce</div>
          <div className='fs-4 bold'>
            <div className='d-flex gap-2'>
              {dataSuggestion?.codePieceEntree}
              {dataSuggestion?.codePieceEntree && (checkCopy !== dataSuggestion?.codePieceEntree ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(dataSuggestion?.codePieceEntree, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Marque véhicule</div>
          <div className='fs-4 bold'>
            {isFromPanier
              ? dataSuggestion?.marquePiece == null
                ? 'NC'
                : dataSuggestion?.marquePiece
              : dataSuggestion?.marqueVehicle == null
              ? 'NC'
              : dataSuggestion?.marqueVehicle}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Modèle véhicule</div>
          <div className='fs-4 bold'>
            {isFromPanier
              ? dataSuggestion?.modelePiece == null
                ? 'NC'
                : dataSuggestion?.modelePiece
              : dataSuggestion?.modeleVehicle == null
              ? 'NC'
              : dataSuggestion?.modeleVehicle}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Etat</div>
          <div className='fs-4 bold'>
            <span className={`badge badge-light-${getEtatColorIndicator()} border border-light-${getEtatColorIndicator()} w-100 justify-content-center fs-5`}>
              {capitalizaFirstletter(dataSuggestion?.etat) || ''}
            </span>
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Date première immatriculation</div>
          <div className='fs-4 bold'>
            {dataSuggestion?.datePremiereImmat == ''
              ? ''
              : moment(dataSuggestion?.datePremiereImmat).format('DD/MM/YYYY')}
          </div>
        </div>
        {isFromPanier && (
          <>
            <div className='d-flex justify-content-between mb-3'>
              <div className='bold text-gray-600 fs-4'>Réference BAC</div>
              <div className='fs-4 bold'>
                {(() => {
                  const refBac = isFromPanier
                    ? dataSuggestion?.refCasier
                    : dataSuggestion?.referenceCasier
                  if (refBac) return refBac
                  return ''
                })()}
              </div>
            </div>
            <div className='d-flex justify-content-between mb-3'>
              <div className='bold text-gray-600 fs-4'>Réference casier</div>
              <div className='fs-4 bold'>
                {(() => {
                  const refAllee = isFromPanier
                    ? dataSuggestion?.refCasierAllee
                    : dataSuggestion?.referenceCasierAllee
                  if (refAllee) return refAllee
                  return ''
                })()}
              </div>
            </div>
          </>
        )}
        <div className='d-flex justify-content-between mb-3 gap-10'>
          <div className='bold text-gray-600 fs-4'>Commentaire</div>
          <div
            className='fs-4 text-gray-700 text-end overflow-y-auto'
            style={{
              maxHeight: '150px',
              maxWidth: '20vw',
            }}
          >
            {dataSuggestion?.commentaires == '' ? 'Nc' : formatTexte(dataSuggestion?.commentaires)}
          </div>
        </div>
        {isFromPanier && (
          <>
            <div className='d-flex justify-content-between mb-3'>
              <div className='bold text-gray-600 fs-4'>Date de stockage</div>
              <div className='fs-4 bold'>
                {dataSuggestion?.nbrJourStockage == ''
                  ? ''
                  : moment(dataSuggestion?.dateStockage).format('DD/MM/YYYY')}
              </div>
            </div>
            <div className='d-flex justify-content-between mb-3'>
              <div className='bold text-gray-600 fs-4'>Jour de stockage</div>
              <div className='fs-4 bold'>
                {dataSuggestion?.nbrJourStockage == '' ? 'Nc' : dataSuggestion?.nbrJourStockage}
              </div>
            </div>
          </>
        )}
        {dataSuggestion?.affichageKilometrage && (
          <div className='d-flex justify-content-between mb-3'>
            <div className='bold text-gray-600 fs-4'>Kilométrage</div>
            <div className='fs-4 bold'>
              {dataSuggestion?.kilometrage != null && dataSuggestion?.kilometrage != 0
                ? `${dataSuggestion.kilometrage.toLocaleString('fr-FR')} km`
                : 'NC'}
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <>
      <div className='modal fade' tabIndex={-1} id='modal_details_piece'>
        <div className='modal-dialog modal-xl'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>
                Détails de { dataSuggestion?.nomTypePieceProposee ?? dataSuggestion?.nom_piece ?? dataSuggestion?.nomTypePiece}
              </h4>
              {!isFromPanier ? (
                <div
                  className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr061.svg'
                    className='svg-icon svg-icon-2x'
                  />
                </div>
              ) : (
                <div
                  className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                  data-bs-target='#kt_modal_1'
                  data-bs-toggle='modal'
                  aria-label='Close'
                >
                  <KTSVG path='/media/svg/custom/prev-arrow.svg' className='svg-icon svg-icon-2x' />
                </div>
              )}
            </div>
            <div className='modal-body'>
              <div className='d-flex gap-4'>
                <div style={{width: '600px'}}>
                  <Carousel
                    loading={true}
                    imagesArray={imgArr}
                    nomPiece={dataSuggestion?.nom_piece}
                    taille={'600x400'}
                    indicator={3}
                    etatColorIndicator={getEtatColorIndicator()}
                    isPOT={dataSuggestion?.isPOT}
                  />
                  <div>
                    <div className='d-flex flex-row-reverse justify-content-between align-items-center'>
                      <div className='fs-2 mb-4 mt-4 text-end'>
                        Prix de vente TTC : {Number(isFromPanier ? dataSuggestion?.prixReferentielTtc : dataSuggestion?.prixProposeeTTC)?.toFixed(2)} €
                      </div>
                    </div>
                  </div>
                </div>
                <div className='card border-0 shadow-none d-flex flex-column w-50'>
                  <h4 className='modal-title ms-9'>
                    Information du produit
                  </h4>
                  <hr className={'text-gray-400 mx-9'} />
                  <div className='card-body mt-n7'>
                    <div>{renderInfo()}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer d-flex gap-3'>
              {isFromPanier ? (
                <button
                  type='button'
                  className='btn btn-light'
                  data-bs-target='#kt_modal_1'
                  data-bs-toggle='modal'
                >
                  Retour
                </button>
              ) : (
                <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                  Fermer
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {DetailsPieceModal}
